/* eslint-disable no-undef */
import React, {useState} from 'react'
import Navbar from '../components/Navbar'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { validateEmail } from '../app/validators';
import { requiredValidator } from '../app/validators';
import { instance } from '../app/axios';
import Regular from '../assets/images/regular-venmo.png';

import coaching from '../assets/images/Chad-Coaching.jpg';
import Footer from '../components/Footer';

export function PhoneInput({placeholder, label, name, type, defaultValue="", error, register, validateFunc}) {
  return (
    <div>
      <label htmlFor="phone-number" className="block text-sm font-medium leading-6 text-gray-200">
        {label}
      </label>
      <div className="relative mt-2 rounded-md shadow-sm">
        <div className="absolute inset-y-0 left-0 flex items-center">
          <label htmlFor="country" className="sr-only">
            Country
          </label>
          <select
            id="country"
            name="country"
            autoComplete="country"
            className="h-full rounded-md border-0 bg-transparent py-0 pl-3 pr-7 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-xs md:text-sm"
          >
            <option>US</option>
            <option>CA</option>
            <option>EU</option>
          </select>
        </div>
        <input
          {...register(name, {validate: validateFunc})}
          type={type}
          name={name}
          defaultValue={defaultValue}
          id="phone-number"
          className="block w-full rounded-md border-0 py-1.5 pl-24 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-xs md:text-sm sm:leading-6"
          placeholder={placeholder}
        />
      </div>
      <p className="mt-2 text-sm" id={`${name}-description`}>
        {error? (<span className="text-rose-500">{error.message}</span>) : null}
      </p>
    </div>
  )
}

export const Input = ({placeholder, label, name, type, defaultValue="", error, register, validateFunc}) => {
  
  return (
    <div className="w-full">
      <label htmlFor={name} className="block text-xs md:text-sm font-medium leading-6 text-gray-200">
        {label}
      </label>
      <div className="mt-1">
        <input
          {...register(name, {validate: validateFunc})}
          type={type}
          name={name}
          id={name}
          className="text-input px-2 text-gray-700 w-full rounded-md py-1 text-xs md:text-sm"
          placeholder={placeholder}
          aria-describedby={`${name}-description`}
          defaultValue={defaultValue}
        />
      </div>
      <p className="mt-2 text-sm text-gray-500" id={`${name}-description`}>
        {error? (<span className="text-rose-500">{error.message}</span>) : null}
      </p>
    </div>
  )
}


export const VenmoCard = ({cost, image}) => {
  return (
    <div className="card bg-white shadow-gray-400 shadow-lg mt-3 flex gap-10 justify-center py-2">
        <div className='card bg-white shadow-lg'><img src={image} className="h-72 w-72"/></div>
        <div className="flex flex-col text-black justify-center">
          <h2>{cost}</h2>
          <h2>Venmo</h2>
          <p className=" italic font-light">@Chad-Poarch</p>
        </div>
      </div>
  )
}

const paymentMethods = [
  { id: 'Regular', title: 'Regular' },
  { id: 'Before/After Care', title: 'Before/After Care' },
]


const Register = () => {
  window.scrollTo(0,0)
  const navigate = useNavigate()
  const {register, handleSubmit, formState: {errors}} = useForm()
  const [paymentMethod, setPaymentMethod] = useState('Regular')
  
  
  const onSubmit = (data) => {
    async function saveData(data) {
      if (paymentMethod === "Regular") {
        data.Regular = "TRUE"
        data["Before/After Care"] = "FALSE"
      } else {
        data.Regular = "FALSE"
        data["Before/After Care"] = "TRUE"
      }
      const result = instance.post('/', data)
      return result
    }
    saveData(data).then(() => {
      navigate('/?success=True')
    }).catch((error) => {
      console.log(error)
    })

    
  }

  return (
    <div>
      <Navbar/>
      
      <div className="flex w-full overflow-hidden">
        <img src={coaching} className="hidden md:block w-1/2 object-cover"/>
        
        <form className="w-full container-padding" onSubmit={handleSubmit(onSubmit)}>
          <h2 className="text-center">Registration</h2>
          <div className="w-full mb-3">
            <h3>Child Details</h3>
            <div className="flex gap-3">
              <Input 
                placeholder={"First Name"}  
                label="First Name"  
                name="firstName"  
                type="text"  
                register={register}  
                validateFunc={requiredValidator}  
                error={errors.firstName}
              />
              <Input 
                
                placeholder={"Last Name"} 
                label="Last Name" 
                name="lastName" 
                type="text" 
                register={register} 
                validateFunc={requiredValidator} 
                error={errors.lastName}/>
            </div>
            <Input placeholder={"Age"} label="Age" name="Age" type="number" register={register} validateFunc={requiredValidator} error={errors["Age"]}/>
          </div>
          
          <div className="w-full">
            <h3>Parent Details</h3>
            <div className="flex gap-3">
              <Input placeholder={"First Name"} label="First Name" name="parentFirstName" type="text" register={register} validateFunc={requiredValidator} error={errors.parentFirstName}/>
              <Input placeholder={"Last Name"} label="Last Name" name="parentLastName" type="text" register={register} validateFunc={requiredValidator} error={errors.parentLastName}/>
            </div>
            <Input placeholder={"Email"} label="email" name="email" type="text" register={register} validateFunc={validateEmail} error={errors.email}/>
            <PhoneInput label={"Phone Number"} placeholder="+1 (555) 987-6543" name="phoneNumber" type="text" register={register} validateFunc={requiredValidator} error={errors.phoneNumber}/>
          </div>

          <div>
            <h3 className="text-gray-200">Payment</h3>
            
            <fieldset className="">
              <legend className="sr-only">Payment method</legend>
              <label className="font-semibold">Package:</label>
              <div className="flex items-center space-x-10 space-y-0">
                
                {paymentMethods.map((notificationMethod) => (
                  <div key={notificationMethod.id} className="flex items-center">
                    <input
                      id={notificationMethod.id}
                      name="notificationMethod"
                      type="radio"
                      onClick={() => setPaymentMethod(notificationMethod.id)}
                      value={paymentMethod}
                      checked={paymentMethod === notificationMethod.id}
                      className="h-4 w-4 border-gray-300 text-gray-200 focus:ring-indigo-600"
                      {...register(notificationMethod.id)}
                    />
                    <label htmlFor={notificationMethod.id} className="ml-3 block text-sm font-medium leading-6 text-gray-200">
                      {notificationMethod.title}
                    </label>
                  </div>
                ))}
              </div>
            </fieldset>
            {paymentMethod === "Regular"? <VenmoCard cost="$250" image={Regular}/> : <VenmoCard cost="$300" image={Regular}/>}
          </div>
          <button className="btn-primary w-full mt-5 rounded-md" type="submit">Submit</button>
        </form>
      </div>
      <Footer/>
    </div>
  )
}

export default Register